import React from 'react'


export default function LoginPrompt({global, dispatch, location, siteMeta}) {

  function handleSignInClick() {
    dispatch({
      type: 'UI_LOGIN',
      data: {},
    })
  }

  return (
    <div
      style={{
        //
      }}
    >

			Sign in to access this page

      <br />

      <button onClick={handleSignInClick}>sign in</button>

    </div>
  )
}
